/** The link URL scheme the plugin gives each entity ID, so the `a` renderer can tell it from a real link. */
export const INLINE_ID_PREFIX = 'agent-id:';
// Page and document IDs are 64-character SHA-256 hex digests; other entity IDs are UUIDs.
// The last branch is an ID the model shortened with an ellipsis (`c2167180c6e3...`, `ef0b4d...45bb`).
const ID_PATTERN = /\b(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b|[0-9a-f]{64}\b|([0-9a-f]{6,})(?:\.{3}|…)([0-9a-f]+\b)?)/gi;
function resolveShortId(prefix, suffix, knownIds) {
    const head = prefix.toLowerCase();
    const tail = suffix?.toLowerCase() ?? '';
    const hits = new Set(knownIds.filter((id) => id.toLowerCase().startsWith(head) && id.toLowerCase().endsWith(tail)));
    return hits.size === 1 ? [...hits][0] : null;
}
function splitIds(value, knownIds) {
    const links = [...value.matchAll(ID_PATTERN)].flatMap((match) => {
        const [text, prefix, suffix] = match;
        const id = prefix ? resolveShortId(prefix, suffix, knownIds) : text;
        return id ? [{ id, start: match.index, end: match.index + text.length }] : [];
    });
    if (links.length === 0)
        return null;
    const nodes = [];
    const end = links.reduce((start, link) => {
        if (link.start > start)
            nodes.push({ type: 'text', value: value.slice(start, link.start) });
        nodes.push({ type: 'link', url: `${INLINE_ID_PREFIX}${link.id}`, children: [{ type: 'text', value: link.id }] });
        return link.end;
    }, 0);
    if (end < value.length)
        nodes.push({ type: 'text', value: value.slice(end) });
    return nodes;
}
function walk(node, knownIds) {
    if (!node.children)
        return;
    node.children = node.children.flatMap((child) => {
        // A link inside a link is invalid, so existing links keep their text as written.
        if (child.type === 'link' || child.type === 'linkReference')
            return [child];
        if ((child.type === 'text' || child.type === 'inlineCode') && child.value) {
            return splitIds(child.value, knownIds) ?? [child];
        }
        walk(child, knownIds);
        return [child];
    });
}
/** Remark plugin: turns each entity ID in text or inline code into an `agent-id:` link, so the panel can render it as a short pill. */
export function remarkInlineIds(options = {}) {
    const knownIds = options.knownIds ?? [];
    return (tree) => walk(tree, knownIds);
}
//# sourceMappingURL=remarkInlineIds.js.map